import * as React from "react";
import Bugsnag from "@bugsnag/js";
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
} from "@reach/accordion";
import { cx } from "@nju/css";
import {
  fetchFAQ,
  IArticle,
  IFaqCategoryName,
} from "@nju/data-access-portal-help";
import { Loader, Markdown, Separator } from "@nju/ui";

type IStates = "IDLE" | "LOADING" | "ERROR" | "DONE";

interface IFAQButtonProps {
  categoryId: IFaqCategoryName;
  count?: number;
  endCount?: number;
  startCount?: number;
  title?: string;
  withSeparator?: boolean;
}

export function FAQButton({
  categoryId,
  count = 1,
  title = "najczęściej zadawane pytania",
  withSeparator = false,
}: IFAQButtonProps) {
  const [currentState, setCurrentState] = React.useState<IStates>("IDLE");
  const [articles, setArticles] = React.useState<IArticle[] | undefined>(
    undefined,
  );

  React.useEffect(() => {
    setCurrentState("LOADING");

    fetchFAQ({ categoryId }).then((result) => {
      if (result.isOk) {
        setArticles(result.value?.[0]?.articles.slice(0, count));

        if (result.value?.[0]?.articles.length === 0) {
          Bugsnag.notify(`No articles for category: ${categoryId}`);
        }

        return setCurrentState("DONE");
      }

      return setCurrentState("ERROR");
    });
  }, [categoryId, count]);

  return (
    <Accordion collapsible={true}>
      <AccordionItem>
        <AccordionButton
          className={cx("underline", !withSeparator && "pb-2")}
          data-cy="faq-button"
        >
          {title}
        </AccordionButton>
        <AccordionPanel>
          {currentState === "IDLE" || currentState === "LOADING" ? (
            <Loader />
          ) : (
            <>
              {withSeparator && <Separator size="xl" />}
              {articles?.map((article) => {
                return (
                  <Markdown
                    as="div"
                    className="prose"
                    content={article.content.pl}
                    key={article.articleId}
                  />
                );
              })}
            </>
          )}
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}
